import { Component,OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { element } from 'protractor';

import * as moment from 'moment';
import { Router } from '@angular/router';

@Component({
    moduleId: module.id,
    selector: 'list-cmp',
    templateUrl: 'list.component.html'
})

export class ListComponent implements OnInit {
    loading:any;

    search:any;

    deviceList:any;
    asc:any;

    toDisplay: boolean = true;

    constructor(private http: HttpClient, private router: Router) {}

    ngOnInit() {     
        this.getDevice();

        const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;

        const comparer = (idx, asc) => (a, b) => ((v1, v2) => 
            v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)
            )(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));

        // do the work...
        document.querySelectorAll('th').forEach(th => th.addEventListener('click', (() => {
            const table = th.closest('table');
            Array.from(table.querySelectorAll('tr:nth-child(n+2)'))
                .sort(comparer(Array.from(th.parentNode.children).indexOf(th), this.asc = !this.asc))
                .forEach(tr => table.appendChild(tr) );
                console.log(this.asc);
                document.querySelectorAll("th").forEach(element => {
                  element.querySelector("i").style.transform = "rotate(0deg)";
                  element.querySelector("i").style.opacity = "0";
                });
                if(this.asc){
                  //ASC
                  th.querySelector("i").style.opacity="1";
                  th.querySelector("i").style.transform = "rotate(0deg)";
                }else{
                  //DESC
                  th.querySelector("i").style.opacity="1";
                  th.querySelector("i").style.transform = "rotate(180deg)";
                }

        })));
        console.log(screen.width);
        if(screen.width < 768){
          this.toDisplay = false;
        }
    }

    getDevice(){
          let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
          };
          this.http.get<any>('https://app.iofrog.com/api/v2/devices/dashboard?limit=100&groupId='+localStorage.getItem("groupId")+'&meta=bodies%2Ccharts%2CwebComponents&searchTree=true&locale=en', {headers}).subscribe((data) => {
            this.loading = false;
            data.data.forEach(element => {
                element.lastSeen = moment(element.lastDataMessage.created).format("DD/MM/YYYY HH:mm");
                element.lastDataMessage.keys.forEach(key => {
                    if(key.key == "action"){
                        element.lastMsg = key.valueLocale;
                    }
                });
                element.trackedKeys.forEach(key => {
                    if(key.key == "mode"){
                        element.mode = key.valueLocale;
                    }
                });
            });
            this.deviceList = data.data; 
            console.log(this.deviceList);    
          }, (error) => {
            this.loading = false;
            if(error.status == 401){
              //this.refreshToken();
              this.logout();
            }
          });
    }

    searchValue(){
      let searchRow:any = document.querySelectorAll(".searching-row");
      searchRow.forEach(element =>{
        element.style.display = "none";
      });
      let searchCell:any = document.querySelectorAll(".searching-cell");
      searchCell.forEach(element =>{
        if(element.innerText.toLowerCase().includes(this.search.toLowerCase())){
          element.parentElement.style.display = "table-row";
        }
      });
    }


    refreshToken(){
      this.loading = true;
      let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
      };
      let body = {
        refreshToken: localStorage.getItem("refreshToken")
      };
      this.http.post<any>('https://admin.iot-tracking.com/api/v2/auth/token/refresh', body ,{headers}).subscribe((data) => {
        this.loading = false;
        localStorage.accessToken = data.token.accessToken;
      }, (error) => {
        this.loading = false;
        console.log(error);
      });
    }

    logout(){
      let headers = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
      };
      let body = {
          refreshToken: localStorage.getItem("refreshToken")
      };
      this.http.post<any>('https://app.iofrog.com/api/v2/auth/token/reject', body ,{headers}).subscribe((data) => {
          localStorage.clear();
          this.router.navigate(['login'], { queryParams: { logout: true } });
      }, (error) => {
          console.log(error);
      });
  }
}
